import React from "react";
import {formatMoney} from "@/utils/MoneyUtils";

type Props = { amount: number, };

const MoneyFormatter = ({amount}: Props) => {
    return (
        <>
            {formatMoney(amount)}
        </>
    );
};

export default MoneyFormatter;